let ISOTOPE,
  FLEX_SLIDER,
  VIEWPORT_WIDTH,
  DISTRIBUTOR_FORM,
  CART_ITEMS = [],
  CART_TOGGLED = false;

/**
 * Custom flex slider
 *
 */
function flexSliderInit() {
  $(window).load(function() {
    $(".flexslider").flexslider({
      smoothHeight: false,
      controlsContainer: $(".custom-controls-container"),
      customDirectionNav: $(".custom-navigation a"),
      slideshowSpeed: 4 * 1000,
      start: function(slider) {
        console.log("start");
        $(".flexslider, .custom-navigation").fadeIn();
        // @TODO: Add loader. Hide loader on start here.
        FLEX_SLIDER = slider;
        $("div#stroke").addClass("stroke_" + slider.animatingTo);
        $(".slider-mobile ul li#slide_" + slider.animatingTo).fadeIn();
      },
      before: function(slider) {
        $("div#stroke").removeClass();
        $(".slider-mobile ul li").hide();
        console.log("slider.animatingTo", slider.animatingTo);

        $("div#stroke").addClass("stroke_" + slider.animatingTo);
        $(".slider-mobile ul li#slide_" + slider.animatingTo).fadeIn();
      }
    });
  });
}

/**
 * Click events
 *
 */
function clickEvents() {
  $(".headerCart").click(function() {
    $("#shopify-section-cart-template").css({
      transform: "translateX(0)"
    });
    $(".drawer-page-content").addClass("active");
    $("body").css("overflow", "hidden");
  });

  $(".cart__header span").click(function() {
    console.log("VIEWPORT_WIDTH", VIEWPORT_WIDTH);

    $("#shopify-section-cart-template").css({
      transform:
        "translateX(" + (VIEWPORT_WIDTH > 768 ? "370px" : "100vw") + ")"
    });
    $(".drawer-page-content").removeClass("active");
    $("body").css("overflow", "visible");
  });

  $(".cart__remove").click(function(params) {
    let removedItemId = $(this).data("clear-line");
    console.log("removedItemId", removedItemId);
    var payload = {
      updates: {}
    };

    $.ajax({
      method: "POST",
      url: "/cart/change.js",
      data: {
        quantity: 0,
        id: removedItemId
      },
      dataType: "json",
      success: function(cart, textStatus, jqXHR) {
        $(".cart-count.header-bar__cart-count").text(cart.item_count);
        $("#CartSection, #CartSectionAsPage").load(
          location.href + " #CartSection>*",
          "",
          function() {
            console.log("reloaded");
            cartInit();
            clickEvents();
          }
        );
      },
      error: function(jqXhr, json, errorThrown) {
        var errorData = jqXhr.responseJSON;
        alert(errorData.description, errorThrown + "!");
      }
    });
  });
}

/**
 * Footer instagram feed
 *
 */
function initIGFeed() {
  var feed = new Instafeed({
    accessToken: "244548239.1677ed0.e7a1bc667c7f446694f32a10a1cb4df2",
    get: "user",
    userId: "244548239",
    limit: 3,
    resolution: "standard_resolution",
    template:
      '<div class="grid__item one-third"> <a href="{{link}}"><div> <img src="{{image}}" width="{{width}}"><div><p>{{model.short_caption}}</p></div></div> </a></div>',
    sortBy: "most-recent",
    filter: function(image) {
      var MAX_LENGTH = 120;

      // here we create a property called "short_caption"
      // on the image object, using the original caption
      if (image.caption && image.caption.text) {
        image.short_caption = image.caption.text.slice(0, MAX_LENGTH) + "...";
      } else {
        image.short_caption = "";
      }

      // ensure the filter doesn't reject any images
      return true;
    }
  });
  feed.run();
}

/**
 * Check current viewport
 *
 */
function checkCurrentViewport() {
  VIEWPORT_WIDTH = $(window).width();
  console.log("checkCurrentViewport", VIEWPORT_WIDTH);
}

function initValues() {
  DISTRIBUTOR_FORM = $("#DistributorsForm").validate({
    submitHandler: function() {
      console.log("Submitted");
      let data = $("#DistributorsForm").serializeArray();
      console.warn("data", data);
      let _data = {};
      for (let i in data) {
        _data[data[i].name] = data[i].value;
      }
      $.ajax({
        method: "POST",
        url: "https://api.streamlinedcampaigns.com/thc-distributors",
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify(_data),
        success: function(result) {
          console.log("result", result);

          let message = result.message;
          $(".distributors__form-message").show();
          $(".distributors__form-message p").html(message);
          console.log("DISTRIBUTOR_FORM", DISTRIBUTOR_FORM);

          DISTRIBUTOR_FORM.resetForm();
          $("#DistributorsForm")
            .get(0)
            .reset();
        },
        error: function(jqXhr, json, errorThrown) {
          console.error("Error:", jqXhr);
          let message =
            'Oops! Something went wrong. Please try again later. <br> <small>If this error still persist even though you\'ve provided a valid information, please contact us at <a href="mailto:jed@streamlinedcampaigns.com">jed@streamlinedcampaigns.com</a> so we can assist you further.</small>';
          $(".distributors__form-message").show();
          $(".distributors__form-message p").append(message);
          DISTRIBUTOR_FORM.resetForm();
          $("#DistributorsForm")
            .get(0)
            .reset();
        }
      });
    }
  });
}

/**
 * Init AOS
 *
 */
function initAOS() {
  AOS.init({
    disable: "phone",
    once: true
  });
}

/**
 * Update cart
 *
 * @param {*} itemId
 * @param {*} counter
 */
function updateCart(itemId, counter, viaClick) {
  var max = parseInt(counter.attr("max"), 10) || 10000;
  var min = 1;
  var value = parseInt(counter.val(), 10) || 0;
  if (value > max) {
    value = max;
    counter.val(max);
  } else if (value < min) {
    value = min;
    counter.val(min);
  }
  let currentItem = CART_ITEMS.find(function(item) {
    return (viaClick ? item.key : item.id) == itemId;
  });
  var payload = {
    updates: {}
  };
  console.log("currentItem", currentItem);

  if (currentItem) {
    payload.updates[currentItem.variant_id] = value;
    $.ajax({
      method: "POST",
      url: "/cart/update.js",
      data: payload,
      dataType: "json",
      success: function(cart, textStatus, jqXHR) {
        let updatedItem = cart.items.find(function(item) {
          return (viaClick ? item.key : item.id) == itemId;
        });
        $(".cart__subtotal-price").html(
          Shopify.formatMoney(cart.total_price, theme.moneyFormat)
        );
        $(".cart-count.header-bar__cart-count").text(cart.item_count);
        $(".item_total_price_" + updatedItem.variant_id).html(
          Shopify.formatMoney(updatedItem.line_price, theme.moneyFormat)
        );
      },
      error: function(jqXhr, json, errorThrown) {
        var errorData = jqXhr.responseJSON;
        alert(errorData.description, errorThrown + "!");
      }
    });
  }
}

/**
 * Init cart events
 *
 */
function initCartEvents() {
  $("[max]").change(function() {
    let itemId = $(this).data("item-id");
    updateCart(itemId, $(this), false);
  });
  $(".quantity__plus-cart").click(function() {
    let itemId = $(this).attr("id");
    let itemIdEscaped = itemId.replace(":", "\\:");
    $("#updates_" + itemIdEscaped).val(
      JSON.parse($("#updates_" + itemIdEscaped).val()) + 1
    );
    let counter = $("#updates_" + itemIdEscaped);
    updateCart(itemId, counter, true);
  });

  $(".quantity__minus-cart").click(function() {
    let itemId = $(this).attr("id");
    let itemIdEscaped = itemId.replace(":", "\\:");
    $("#updates_" + itemIdEscaped).val(
      JSON.parse($("#updates_" + itemIdEscaped).val()) - 1
    );
    let counter = $("#updates_" + itemIdEscaped);
    updateCart(itemId, counter, true);
  });
}

/**
 * Initiate Cart
 *
 */
function cartInit() {
  console.log("cartInit");

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function(result) {
      for (let i in result.items) {
        CART_ITEMS.push(result.items[i]);
      }
      initCartEvents();
    },
    error: function(jqXhr, json, errorThrown) {
      console.error("GET cart error: ", jqXhr);
    }
  });
}

function initAppJS() {
  console.log = function() {};
  console.log("%c app.js init", "color: green");
  checkCurrentViewport();
  flexSliderInit();
  clickEvents();
  initValues();
  initAOS();
  //initIGFeed();
  cartInit();
  document.addEventListener("aos:in:super-duper", ({ detail }) => {
    console.log("animated out", detail);
    detail.play();
  });
}

$(document).resize(checkCurrentViewport);
$(document).ready(initAppJS);
